import React from 'react';
import './QueryResults.css';

function QueryResults() {
  const shapes = [
    { id: 1, size: 'large' },
    { id: 2, size: 'medium' },
    { id: 3, size: 'medium' },
    { id: 4, size: 'small' },
    { id: 5, size: 'small' },
    { id: 6, size: 'wide' },
    { id: 7, size: 'small' },
    { id: 8, size: 'small' },
    { id: 9, size: 'medium' },
    { id: 10, size: 'small' },
    { id: 11, size: 'small' },
    { id: 12, size: 'medium' }
  ];

  return (
    <div className="ONCRP-TOOLS-QP-results-container">
      <div className="ONCRP-TOOLS-QP-results-grid">
        {shapes.map((shape) => (
          <div key={shape.id} className={`ONCRP-TOOLS-QP-shape ONCRP-TOOLS-QP-${shape.size}`}>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QueryResults; 